import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"150px"},
  src: "/images/logo.png",
  alt: "Newtech Life"
}, null, -1)


import { defineComponent } from 'vue'
import MenuItemRender from './MenuItemRender.vue'
import store from '../store'
import { findTreeNode, MenuTree, isEmptyArray } from '../utils'
import { loginPath, rootEnglishPath, rootChinesePath } from '../config'

// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'HeaderMenuRender'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const handleSelect = (key:string, keyPath:string[]) => {
  if (key === 'logout_menu') {
    document.cookie = 'AuthorizationToken=; Max-Age=-99999999;'
    window.location.href = loginPath
  } else if (key === 'switch_english_menu') {
    window.location.href = rootEnglishPath
  } else if (key === 'switch_chinese_menu') {
    window.location.href = rootChinesePath
  }
  // 只有 tag 是 el-menu-item 的菜单才可点击
  // 横向菜单，是 el-menu-item， 同时有 子菜单， 则 子菜单 挂在到 左侧
  // 横向菜单，是 el-sub-menu， 响应 handleSelect 时， 只有子菜单是 el-menu-item 的子菜单， 才会响应
  const result = findTreeNode(store.state.meunTree, key, '', 0)
  if (result === null) {
    return
  }
  const menu = result.node as MenuTree
  if (isEmptyArray(menu.children)) {
    return
  }
  store.state.leftMenu = menu.children as MenuTree[]
}


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": _unref(store).state.homeMenuIndex,
    class: "el-menu-demo",
    mode: "horizontal",
    ellipsis: false,
    onSelect: handleSelect
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu_item, {
        index: _unref(store).state.homeMenuIndex,
        style: {"padding":"0px"}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["index"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.meunTree, (item) => {
        return (_openBlock(), _createBlock(MenuItemRender, {
          item: item,
          key: item.id
        }, null, 8, ["item"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})